/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                    from 'react';
import ReactDOM                 from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';
import { Provider }             from 'react-redux';
import { App }                  from './components/App';
import { AppStore }             from './store';
import ScrollToTop              from './components/atoms/ScrollToTop';
import Preload                  from 'preload-img';
import Terrace3                 from './images/terrace-3.jpg';
import Terrace4                 from './images/terrace-4.jpg';
import ServiceWorker            from './registerServiceWorker';
import Analytics                from './analytics';


/*********************************************************************************
 2. Imports
 *********************************************************************************/

import './styles/fonts.css';


/*********************************************************************************
 3. Setup
 *********************************************************************************/

ReactDOM.render(
    <Provider store={AppStore}>
        <BrowserRouter>
            <ScrollToTop>
                <Route component={Analytics(App, { /* additional attributes */ } )} />
            </ScrollToTop>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);


/*********************************************************************************
 4. HMR
 *********************************************************************************/

if (module.hot) {
    module.hot.accept();
}


/*********************************************************************************
 5. Preload images
 *********************************************************************************/

Preload(Terrace3);
Preload(Terrace4);


/*********************************************************************************
 6. Register Service Worker
 *********************************************************************************/

ServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js